import { render, staticRenderFns } from "./CartFooter.vue?vue&type=template&id=b5835c9c&scoped=true"
import script from "./CartFooter.vue?vue&type=script&lang=js"
export * from "./CartFooter.vue?vue&type=script&lang=js"
import style0 from "./CartFooter.vue?vue&type=style&index=0&id=b5835c9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5835c9c",
  null
  
)

export default component.exports